<!-- goBackWindow -->
<template>
  <van-dialog
    v-model="show"
    :show-confirm-button="false"
    :show-cancel-button="false"
    :close-on-click-overlay="true"
    :before-close="beforeClose"
  >
    <img
      class="background-image"
      src="../../assets/img/components/rententionDialog/background.png"
      alt
    />
    <div
      class="text-content"
      @click="stay"
    >
      <div
        class="text-bar"
        v-for="(item, index) in contentText"
        :key="index"
      >
        <div class="text">{{ item }}</div>
        <div class="text-btn">GO</div>
      </div>
      <div @click.stop="close" class="close-btn">
        <span>残忍拒绝</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => { },
    },
    onStay: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      show: false,
      contentText: ['问问老师还能更优惠', '我想免费试听一下', '再领一份备考资料吧'],
    };
  },
  watch: {
    dialogShow(showStatus) {
      this.show = showStatus;
    },
  },

  components: {},

  mounted() { },

  methods: {
    beforeClose(action, done) {
      this.$emit('close');
      done();
    },
    close() {
      this.$emit('close');
      this.onClose();
    },

    stay() {
      this.$emit('close');
      this.onStay();
    },
  },
};
</script>

<style lang="scss" scoped>
$remSize: 75;
$fontHeight: calc(29rem / 75);
@function remcalc($rem) {
  @return calc($rem / $remSize) * 1rem;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.52);
}
.van-dialog {
  width: remcalc(543);
  height: remcalc(674);
  overflow: visible;
  border-radius: remcalc(14);

  .van-hairline--top::after {
    display: none;
  }
}

.background-image {
  position: relative;
  top: -63px;
  width: 543px;
  height: 737px;
}

.text-content {
  position: absolute;
  top: 298px;
  left: 36px;

  .text-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 471px;
    height: 72px;
    margin-bottom: 22px;
    background: #fef5f1;
    border-radius: 67px;

    .text {
      margin-left: 25px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
    }

    .text-btn {
      width: 91px;
      height: 72px;
      color: #fff;
      font-weight: 600;
      font-size: 29px;
      line-height: 72px;
      text-align: center;
      background: #ff7f41;
      border-radius: 67px;
    }
  }

  .close-btn {
    height: 76px;
    color: #666;
    font-weight: 400;
    font-size: 25px;
    text-align: center;
    span{
      display: inline-block;
      width: 200px;
      height: 100%;
      line-height: 70px;
    }
  }
}
</style>
